export default {
	'地毯颜色选择': '地毯颜色选择',
	'请选择需要的地毯颜色': '请选择需要的地毯颜色',
	'不需要地毯': '不需要地毯',
	'上一步': '上一步',
	'下一步': '下一步',
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsCarpet.js